import { configureStore } from '@reduxjs/toolkit';
import sessionReducer from './sessionSlice'; 
import authReducer from "../pages/loginSlice";   
import uiReducer  from "../pages/uiSlice";   

export const store = configureStore({
  reducer: {
    session: sessionReducer,
    auth:authReducer,
    ui:uiReducer 
  }
});